import React, { useLayoutEffect } from 'react';
import { ArrowLeft, GraduationCap } from 'lucide-react';
import { FAQSection } from '../components/sections/FAQSection';
import { ContactFooter } from '../components/sections/ContactFooter';

export const FAQPage = () => {
  useLayoutEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  }, []);

  const handleBackToHome = () => {
    window.location.href = '/';
  };

  const handleLogoClick = () => {
    window.location.href = '/';
  };

  return (
    <main className="min-h-screen">
      {/* Header - Made Sticky */}
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b shadow-lg" style={{borderColor: '#6B4423'}}>
        <div className="container mx-auto px-3 sm:px-4 md:px-6 py-2 sm:py-2 md:py-3">
          <div className="flex items-center justify-between">
            {/* Left: Back button and A2ZCampus Logo */}
            <div className="flex items-center">
              <button
                onClick={handleBackToHome}
                className="mr-2 sm:mr-3 p-1 sm:p-2 rounded-full hover:bg-gray-100 transition-colors"
                aria-label="Back to home"
              >
                <ArrowLeft className="w-4 h-4 sm:w-5 sm:h-5" style={{color: '#6B4423'}} />
              </button>
              <button 
                onClick={handleLogoClick}
                className="flex items-center hover:opacity-80 transition-opacity cursor-pointer"
                aria-label="Go to home page"
              >
                <img 
                  src="/A2ZAssist%20logo.png" 
                  alt="A2ZCampus Logo" 
                  className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 lg:w-16 lg:h-16 mr-1 object-contain"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.style.display = 'none';
                  }}
                />
                <div className="flex items-center">
                  <span className="font-bold text-base sm:text-lg md:text-xl lg:text-2xl tracking-tight" style={{color: '#2C2420'}}>A2Z</span>
                  <span className="font-bold text-base sm:text-lg md:text-xl lg:text-2xl tracking-tight" style={{color: '#6B4423'}}>Campus</span>
                  <span className="text-xs sm:text-sm md:text-sm lg:text-base font-bold ml-1 align-top" style={{color: '#6B4423'}}>™</span>
                </div>
              </button>
            </div>
            
            {/* Right: FAQ Badge */}
            <div className="hidden lg:flex items-center bg-white border-2 rounded-2xl px-4 py-2 shadow-lg" style={{borderColor: '#C4A052'}}>
              <GraduationCap className="w-5 h-5 mr-2" style={{color: '#C4A052'}} />
              <div className="flex items-center">
                <span className="font-bold text-base" style={{color: '#6B4423'}}>Frequently Asked Questions</span>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-4 sm:py-6 md:py-8" style={{backgroundColor: '#FAF7F2'}}>
        <div className="container mx-auto px-3 sm:px-4 md:px-6">
          <div className="max-w-6xl mx-auto text-center">
            {/* Mobile FAQ Badge */}
            <div className="lg:hidden flex justify-center mb-2 sm:mb-3 md:mb-4">
              <div className="flex items-center bg-white border-2 rounded-2xl px-3 py-2 sm:px-4 sm:py-2 md:px-5 md:py-2 shadow-lg" style={{borderColor: '#C4A052'}}>
                <GraduationCap className="w-4 h-4 sm:w-5 sm:h-5 md:w-5 md:h-5 mr-2 md:mr-3" style={{color: '#C4A052'}} />
                <div className="flex flex-col items-center">
                  <span className="font-bold text-xs sm:text-sm md:text-base text-center" style={{color: '#6B4423'}}>FAQ</span>
                </div>
              </div>
            </div>

            <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold mb-2 sm:mb-3 md:mb-4 px-2" style={{color: '#2C2420'}}>
              Frequently Asked <span style={{color: '#C4A052'}}>Questions</span>
            </h1>
            
            <p className="text-sm sm:text-base md:text-lg lg:text-xl max-w-4xl mx-auto leading-relaxed mb-2 sm:mb-2 md:mb-3 font-medium px-3" style={{color: '#6B4423'}}>
              Everything you need to know about A2ZCampus™ and our ThinkTech platform
            </p>
            
            <p className="text-xs sm:text-sm md:text-base lg:text-lg max-w-4xl mx-auto leading-relaxed mb-3 sm:mb-4 md:mb-6 px-3" style={{color: '#2C2420'}}>
              Get answers to common questions about our proprietary learning tools — 
              <span style={{color: '#6B4423'}} className="font-bold"> ClarityKit™</span>, 
              <span style={{color: '#6B4423'}} className="font-bold"> Startup Simulator™</span>, and 
              <span style={{color: '#6B4423'}} className="font-bold"> Real World Readiness™</span> — and how to get involved.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Content */}
      <FAQSection />
      <ContactFooter />
    </main>
  );
};